import { Trans } from 'react-i18next'

const ExistingItfCustomerText = () => (
  <>
    {' '}
    <Trans ns='strRegister' i18nKey={'introAlreadyCustomer.1'}>
      It looks like you already have an ITF Tennis ID user account with one of the ITF’s other
      online services such as IPIN or ITF Academy.
    </Trans>
    <br />
    <br />
    <Trans ns='strRegister' i18nKey={'introAlreadyCustomer.2'}>
      Please press CONTINUE to sign in using your existing ITF account email and password to
      complete your registration for <strong>ITF World Tennis Number</strong>.
    </Trans>
  </>
)

export default ExistingItfCustomerText
